import React from 'react';

interface ImageCategorizationIconProps {
  style?: React.CSSProperties;
}

const ImageCategorizationIcon: React.FC<ImageCategorizationIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Image Categorization</title>
      <path d="M25.98 7.5v15L0 7.5 12.99 0l12.99 7.5z" fill="#DD45D3" />
      <path d="M25.98 22.5L12.99 30 0 22.5 12.99 15l12.99 7.5z" fill="#943CFF" />
      <path d="M0 7.5v15L12.99 15 0 7.5z" fill="#FD9D52" />
    </svg>
  );
};

export default ImageCategorizationIcon;
